export const RATE_CONFIG = {
  API_BASE_URL: 'https://api.exchangerate-api.com/v4',
  BACKUP_API_URL: 'https://api.fxratesapi.com/v1',
  TIMEOUT: 8000,
  RETRY_ATTEMPTS: 2,
  CACHE_TTL: 60000, // 1 minute cache for live data
  REFETCH_INTERVAL: 60000, // Refetch every minute for live updates
  STALE_TIME: 30000, // 30 seconds stale time
  BATCH_SIZE: 10
} as const;

export const ERROR_MESSAGES = {
  FETCH_FAILED: 'Failed to fetch live exchange rates',
  INVALID_RESPONSE: 'Invalid response from rate service',
  RATE_NOT_FOUND: (currency: string) => `Exchange rate not found for ${currency}`,
  SERVICE_UNAVAILABLE: 'Rate service is temporarily unavailable',
  ALL_SOURCES_FAILED: 'All rate sources are currently unavailable'
} as const;